import React, { useEffect } from 'react';
import { EspaceAtna } from '../components/espace/EspaceAtna';
import { ForYouFeed } from '../components/espace/ForYouFeed';
import { LocalNews, NearbyEvents, UsefulServices } from '../components/espace/LocalContent';
import { AppPromo } from '../components/espace/AppPromo';
import { citizenFirstName } from '../data/espace';
import { useEspace } from '../contexts/EspaceContext';
export function MonEspace() {
  const {
    enterEspace
  } = useEspace();
  useEffect(() => {
    enterEspace();
  }, [enterEspace]);
  return <main className="min-h-screen bg-white" data-id="element-3044" data-mp="12900q8qhboqr">
      <div className="px-5 py-10 lg:px-10" data-id="element-3045" data-mp="nc9aoq2p3pdt">
        <header data-id="element-3046" data-mp="nbfz9bsskbpc">
          <h1 className="text-3xl font-extrabold tracking-tight text-ville-navy lg:text-4xl" data-id="element-3047" data-mp="nbzkb1dqng7l">
            Bonjour {citizenFirstName}
          </h1>
          <p className="mt-1 text-[17px] text-slate-600" data-id="element-3048" data-mp="381yp51zhl95z">Voici ce qui vous concerne aujourd’hui.</p>
        </header>

        <div className="mt-6 max-w-3xl" data-id="element-3049" data-mp="3d1tcwwnytimt">
          <EspaceAtna data-id="element-3050" data-mp="3czgn5xbyu3z7" />
        </div>

        <ForYouFeed data-id="element-3051" data-mp="1ax39nt8amqpi" />
        <LocalNews data-id="element-3052" data-mp="1aympjiq1ezqr" />
        <NearbyEvents data-id="element-3053" data-mp="1ay4w0turezmj" />
        <UsefulServices data-id="element-3054" data-mp="1azg250bogjgt" />
        <AppPromo data-id="element-3055" data-mp="15ys3bsh7iyc1" />
      </div>
    </main>;
}